export default class TranslationDB {
  constructor(dbName = 'TranslationDB') {
    this.dbName = dbName;
    this.db = null;
  }
  
  async open() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1);
      
      request.onerror = () => reject(request.error);
      
      request.onsuccess = () => {
        this.db = request.result;
        resolve(this);
      };
      
      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('translations')) {
          const store = db.createObjectStore('translations', {
            keyPath: ['lang', 'key']
          });
          store.createIndex('by_lang', 'lang', { unique: false });
        }
      };
    });
  }
  
  async saveTranslations(lang, translations) {
    if (!this.db) await this.open();
    
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(['translations'], 'readwrite');
      const store = transaction.objectStore('translations');
      
      // 清除现有数据
      const clearRequest = store.index('by_lang').openCursor(IDBKeyRange.only(lang));
      
      clearRequest.onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          cursor.delete();
          cursor.continue();
        } else {
          // 添加新数据
          const entries = Object.entries(translations);
          let count = 0;
          
          if (entries.length === 0) {
            transaction.oncomplete = () => resolve();
            return;
          }
          
          entries.forEach(([key, value]) => {
            const request = store.put({ lang, key, value });
            request.onerror = () => reject(request.error);
            request.onsuccess = () => {
              count++;
              if (count === entries.length) {
                transaction.oncomplete = () => resolve();
              }
            };
          });
        }
      };
      
      clearRequest.onerror = () => reject(clearRequest.error);
      transaction.onerror = () => reject(transaction.error);
    });
  }
  
  async getTranslations(lang) {
    if (!this.db) await this.open();
    
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(['translations'], 'readonly');
      const store = transaction.objectStore('translations');
      const index = store.index('by_lang');
      
      const request = index.getAll(IDBKeyRange.only(lang));
      
      request.onsuccess = () => {
        const result = {};
        request.result.forEach(item => {
          result[item.key] = item.value;
        });
        resolve(result);
      };
      
      request.onerror = () => reject(request.error);
    });
  }
}
